module.exports = __webpack_public_path__ + "img/logo.168328fd.png";